export const TABLE_ICONS = {
  data: "tableDensityNormal",
  analysis: "indexMapping",
  workflow: "layers",
  input: "logstashInput",
  output: "logstashOutput",
} as const;

export const DRS_FILE_ACTION_ICONS = {
  archive: "snowflake",
  delete: "trash",
  unarchive: "tear",
  assign: "link",
  unassign: "unlink",
  createSeries: "listAdd",
  revertSeries: "indexFlush",
  rename: "pencil",
  download: "download",
  upload: "exportAction",
  cancel_upload: "cross",
  inspect: "eye",
  identify: "documentEdit",
} as const;

export const COLUMN_TYPE_ICONS = {
  dataColumn: DRS_FILE_ACTION_ICONS.upload,
  analysisResult: TABLE_ICONS.analysis,
  customMetadata: "indexEdit",
  linkedMetadata: "link",
} as const;
